import { Component, OnInit } from '@angular/core';
import { DesignationDto } from 'src/app/models/DesignationDto';
import { DesignationService } from 'src/app/services/designation.service';
import { NzTableModule } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-view-designation',
  templateUrl: './view-designation.component.html',
  styleUrls: ['./view-designation.component.css']
})
export class ViewDesignationComponent implements OnInit {
  Designations:DesignationDto[]=[];
  constructor(private designationService:DesignationService) { }

  ngOnInit(): void {
    this. loadRecords();
  }
  async  loadRecords()
  {
    
    let  resLocations = await this.designationService.getDesignations().toPromise(); 
    this.Designations = <DesignationDto[]> resLocations.responseData;

  }
}
